import dashboard from '@/router/modules/default/dashboard'
import pacotesfornecedor from '@/router/modules/default/pacotesfornecedor'
import pacotesunidade from '@/router/modules/default/pacotesunidade'
import empresa from '@/router/modules/default/empresa'
import unidade from '@/router/modules/default/unidade'
import usuario from '@/router/modules/default/usuario'
// import regrastabelas from '@/router/modules/default/regrastabelas'
import comissao from '@/router/modules/default/comissao'
// import contrato from '@/router/modules/default/contrato'
// import roteiro from '@/router/modules/default/roteiro'
// import link from '@/router/modules/default/link'
import comunicado from '@/router/modules/default/comunicado'
import perfil from '@/router/modules/default/perfil'
import listagem from '@/router/modules/default/listagem'
import regras from '@/router/modules/default/regras'
import novoscadastros from '@/router/modules/default/novoscadastros'
import comissaovendedores from '@/router/modules/default/comissao-vendedores'
import limiteusuarios from '@/router/modules/default/limiteusuarios'
import limitecadastrosdiarios from '@/router/modules/default/limitecadastrosdiarios'
import usuariosativos from '@/router/modules/default/usuariosativos'
import gerenciarleads from '@/router/modules/default/gerenciarleads'
import vendedor from '@/router/modules/default/vendedor'
import usuariosativosvendedor from '@/router/modules/default/usuariosativosvendedor'
import planosassinaturas from '../../../router/modules/default/planosassinaturas'
import assinatura from '@/router/modules/default/assinatura'
import repassecomissao from '@/router/modules/default/repassecomissao'
import statusassinatura from '@/router/modules/default/statusassinatura'
import promotora from '@/router/modules/default/promotora'
import consultasparceiro from '@/router/modules/default/consultasparceiro'
import regrasbancos from '@/router/modules/default/regrasbancos'
import instituicoes from '@/router/modules/default/instituicoes'
import financeiro from '@/router/modules/default/financeiro'

export default [
  ...dashboard,
  ...listagem,
  ...promotora,
  ...financeiro,
  {
    name: 'Gerenciador',
    icon: 'fa fa-cog',
    id: 'gerenciador',
    sub: [
      // ...regrastabelas,
      ...comunicado,
      // ...comissao,
      ...pacotesfornecedor,
      ...pacotesunidade,
      ...empresa,
      ...unidade,
      ...limiteusuarios,
      ...perfil,
      ...usuario,
      // ...contrato,
      ...limitecadastrosdiarios,
      // ...roteiro
      // ...link
      ...vendedor
    ]
  },
  {
    name: 'Tabelas',
    icon: 'fa fa-file-text-o',
    id: 'tabelascomissao',
    sub: [
      ...comissao,
      ...regras,
      ...regrasbancos,
      ...instituicoes
    ]
  },
  {
    name: 'Adm-Financeiro',
    icon: 'fa fa-usd',
    id: 'admfinanceiro',
    sub: [
      ...statusassinatura,
      ...planosassinaturas,
      ...assinatura,
      ...repassecomissao,
      ...comissaovendedores
    ]
  },
  {
    name: 'Relatórios',
    icon: 'fa fa-bar-chart',
    id: 'relatorios',
    sub: [
      ...novoscadastros,
      ...gerenciarleads,
      ...usuariosativos,
      ...usuariosativosvendedor,
      ...consultasparceiro
    ]
  }
]



// WEBPACK FOOTER //
// ./src/store/modules/acesso/menu.js